import React, { useEffect, createElement } from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { TrustBar } from './components/TrustBar';
import { PainPoints } from './components/PainPoints';
import { Features } from './components/Features';
import { Chapters } from './components/Chapters';
import { Testimonial } from './components/Testimonial';
import { Pricing } from './components/Pricing';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
declare global {
  interface Window {
    fbq: (...args: unknown[]) => void;
    _fbq: (...args: unknown[]) => void;
  }
}
const PIXEL_ID = '2127471088190047';
const PAGE_TITLE = 'Zen 2026: Guía Práctica de Budismo y Mindfulness';
const PAGE_DESCRIPTION = 'Descubre la sabiduría budista para encontrar calma, presencia y energía masculina en la era digital.';
const setMetaTag = (attr: 'name' | 'property', key: string, content: string) => {
  let tag = document.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute(attr, key);
    document.head.appendChild(tag);
  }
  tag.setAttribute('content', content);
};
export function App() {
  useEffect(() => {
    // SEO + social preview
    document.title = PAGE_TITLE;
    setMetaTag('name', 'description', PAGE_DESCRIPTION);
    setMetaTag('property', 'og:title', PAGE_TITLE);
    setMetaTag('property', 'og:description', PAGE_DESCRIPTION);
    setMetaTag('property', 'og:type', 'website');
    setMetaTag('name', 'twitter:card', 'summary_large_image');
    setMetaTag('name', 'twitter:title', PAGE_TITLE);
    setMetaTag('name', 'twitter:description', PAGE_DESCRIPTION);
    // Initialize Meta Pixel (only once)
    if (!window.fbq) {
      const n: any = window.fbq = function (...args: unknown[]) {
        n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
      };
      if (!window._fbq) window._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
    }
    window.fbq('init', PIXEL_ID);
    window.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-[#0A192F] text-[#FFF8F0] selection:bg-[#D4AF37]/30 selection:text-[#FFF8F0]" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <TrustBar data-id="element-4" />
        <PainPoints data-id="element-5" />
        <Features data-id="element-6" />
        <Chapters data-id="element-7" />
        <Testimonial data-id="element-8" />
        <Pricing data-id="element-9" />
        <FAQ data-id="element-10" />
      </main>
      <Footer data-id="element-11" />
    </div>;
}